import React from 'react'
import style from './MasProductos.module.css'

import imagen1 from '../../../../utils/images/box-1.png'
import imagen4 from '../../../../utils/images/box-4.png'
import CardProductos from '../../../generales/CardProductos'

const MasProductos = ({ t }) => {

  return (
    <div className={style.container}>
      <p className={style.titulo}>{t('Products.BusinessSolution.More-products.title')}</p>
      <div className={style.productos}>
        <CardProductos
          imagen={imagen4}
          link={"/productos/ssc-enterprise"}
          title={"HomePage.Products.supervision-and-control-system"}
          text={"HomePage.Products.description-of-supervision-and-control-system"}
        />
        <CardProductos
          imagen={imagen1}
          link={"/productos/business-solution"}
          title={"HomePage.Products.business-solution"}
          text={"HomePage.Products.description-of-business-solution"}
        />
      </div>
    </div>
  )
}

export default MasProductos